'use strict';

(function () {
  'use strict';

  angular.module('msCore').factory('AuditSvc', AuditSvc);

  AuditSvc.$inject = ['httpSvc', 'msAuth'];

  /* @ngInject */
  function AuditSvc(httpSvc, msAuth) {
    return {
      generateAuditEvent: generateAuditEvent,
      generateTelehealthAuditEvent: generateTelehealthAuditEvent
    };

    ////////////////

    function generateAuditEvent(eventAudit) {
      if (msAuth.isLoggedIn()) {
        return httpSvc.post('/apiproxy/user/audit', eventAudit);
      } else {
        return httpSvc.post('/apiproxy/public/audit', eventAudit, {
          withCredentials: false
        });
      }
    }

    function generateTelehealthAuditEvent(telehealthEvent) {
      return httpSvc.post('/apiproxy/user/audit/telehealth', telehealthEvent);
    }
  }
})();